module.exports = __webpack_public_path__ + "img/aboutPage_service_icon55.0a57d95e.png";